<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-data-table
          :headers="monthItemDataTableHeaders"
          :items="newMonthItemList"
          :search="searchMonthItem"
          class="elevation-1"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          item-key="Index"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('quotation_item_new_tool_bar_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchMonthItem"
                append-icon="mdi-magnify"
                :label="$t('quotation_item_new_install_search')"
                single-line
                hide-details
                clearable
              ></v-text-field>
              <!-- <v-btn
                color="primary"
                class="mb-2 ml-8"
                :disabled="isAllTextFieldDisabled"
                @click="openMonthItem"
              >
                {{ $t('quotation_item_new_install_new_item_btn') }}
              </v-btn> -->
              <v-dialog
                v-model="isShowEditMonthItemDialog"
                v-if="isShowEditMonthItemDialog"
                persistent
              >
                <v-card>
                  <v-card-title>
                    <span class="text-h5">{{ $t('quotation_item_new_month') }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <ValidationObserver ref="dialogMonthItem">
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <month-item-autocomplete
                              :fatherEditedItem="editedMonthItem"
                              :itemName="'quotation_item_number'"
                              @setEditedMonthItem="setEditedMonthItem"
                              v-if="editedMonthItemIndex === -1"
                              refName="monthItemAutocomplete"
                              @keyupEnter="focusNextInput"
                            />
                            <ValidationProvider
                              :name="$t('quotation_item_number')"
                              rules="required"
                              v-slot="{ errors }"
                              v-else
                            >
                              <v-text-field
                                v-model="editedMonthItem.Number"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_number') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_name')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Name"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_name') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_unit')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Unit"
                                disabled
                                :error-messages="errors[0]"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_unit') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('month_quantity')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Quantity"
                                :error-messages="errors[0]"
                                :suffix="$t('unlimited_month_suffix_months')"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('month_quantity') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            lg="3"
                            xl="3"
                            v-if="editedMonthItem.PayType === payType.Quantity"
                          >
                            <ValidationProvider
                              :name="$t('unlimited_month_pay_quantity')"
                              :rules="{ required: true, regex: /^\d+\.?\d*$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.PayQuantity"
                                :error-messages="errors[0]"
                                :suffix="$t('unlimited_month_suffix_units')"
                                @change="changeMonthTotal"
                                @keyup.enter="focusNextInput"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('unlimited_month_pay_quantity') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <v-text-field
                              v-model="editedMonthItem.LicensePlate"
                              :label="$t('transfer_order_license_plate')"
                              disabled
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Price"
                                :error-messages="errors[0]"
                                disabled
                                @change="changeMonthTotal"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('unlimited_month_discount')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.Discount"
                                :error-messages="errors[0]"
                                disabled
                                @change="changeMonthTotal"
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('unlimited_month_discount') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('unlimited_month_discount_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.DiscountPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('unlimited_month_discount_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_total_price')"
                              :rules="{
                                required: true,
                                regex:
                                  editedMonthItem.PayType === payType.Quantity
                                    ? /^\d+\.?\d*$/
                                    : /^[0-9]+$/,
                              }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.TotalPrice"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_total_price') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('quotation_item_rent_warranty_period')"
                              :rules="{ required: true, regex: /^[0-9]+$/ }"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                v-model="editedMonthItem.RentWarrantyPeriod"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('quotation_item_rent_warranty_period') }}
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('unlimited_month_pay_type')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayType"
                                :items="allPayType"
                                item-text="Name"
                                item-value="Type"
                                :loading-text="$t('common_get_data')"
                                :no-data-text="$t('common_no_data')"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('unlimited_month_pay_type') }}
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                            <ValidationProvider
                              :name="$t('unlimited_month_pay_time_range')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayTimeRangeType"
                                :items="payTimeRangeTypeList"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('unlimited_month_pay_time_range') }}
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                          <v-col
                            v-if="editedMonthItem.PayType === payType.Quantity"
                            cols="12"
                            sm="6"
                            md="3"
                            lg="3"
                            xl="3"
                          >
                            <ValidationProvider
                              :name="$t('unlimited_month_pay_quantity_type')"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-autocomplete
                                v-model="editedMonthItem.PayQuantityType"
                                :items="allPayQuantityType"
                                item-text="Name"
                                item-value="Type"
                                :error-messages="errors[0]"
                                disabled
                              >
                                <template v-slot:label>
                                  <span class="red--text">
                                    <strong>* </strong>
                                  </span>
                                  {{ $t('unlimited_month_pay_quantity_type') }}
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-textarea
                              outlined
                              :label="$t('quotation_item_remark')"
                              v-model="editedMonthItem.Remark"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </ValidationObserver>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closeEditedMonthItem">
                      {{ $t('common_cancel') }}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="saveEditedMonthItem">
                      {{ $t('common_save') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <delete-dialog
                :isAllTextFieldDisable="false"
                :isLoadingSaveBtn="false"
                :isShowDeleteDialog="isShowDeleteMonthItemDialog"
                :deleteMessage="'quotation_item_delete_item_dialog_title'"
                @closeDelete="closeDeleteMonthItem"
                @confirmDelete="confirmDeleteMonthItem"
              />
            </v-toolbar>
          </template>
          <template v-slot:[`item.PayType`]="{ item }">
            {{ turnPayType(item.PayType) }}
          </template>
          <template v-slot:[`item.PayTimeRangeType`]="{ item }">
            {{ turnPayTimeRangeTypeName(item.PayTimeRangeType) }}
          </template>
          <template v-slot:[`item.PayQuantityType`]="{ item }">
            {{ turnPayQuantityTypeName(item.PayQuantityType) }}
          </template>
          <template v-slot:[`item.Edit`]="{ item }">
            <v-btn
              icon
              @click="isShowEditMonthItemDialogBtn(item)"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="isShowDeleteMonthItemDialogBtn(item)"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon small>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.Move`]="{ item, index }">
            <v-btn
              icon
              @click="upMonthItem(item)"
              v-if="index !== 0"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon>
                mdi-arrow-up-drop-circle-outline
              </v-icon>
            </v-btn>
            <v-btn
              icon
              @click="downMonthItem(item)"
              v-if="index !== newMonthItemList.length - 1"
              :disabled="isAllTextFieldDisabled"
            >
              <v-icon>
                mdi-arrow-down-drop-circle-outline
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DeleteDialog from '@/components/DeleteDialog.vue'
import MonthItemAutocomplete from '@/components/MonthItemAutocomplete.vue'
import { PayType } from '@/js/PayType'
import { HttpMonth } from '@/js/http-Manager'
import { PayTimeRangeType } from '@/js/PayTimeRangeType'
import { PayQuantityType } from '@/js/PayQuantityType'

export default {
  components: { MonthItemAutocomplete, DeleteDialog },
  name: 'UnlimitedMonthSetting',

  data: () => ({
    payType: PayType,
    searchMonthItem: '',
    editedMonthItemIndex: -1,
    isShowEditMonthItemDialog: false,
    isShowDeleteMonthItemDialog: false,
    editedMonthItem: {
      Number: '',
      Name: '',
      Quantity: 1,
      PayQuantity: 0,
      AddPayQuantity: 0,
      RentQuantity: 1,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0,
      PayType: 3,
      PayTimeRangeType: 1,
      PayQuantityType: 2,
      LicensePlate: ''
    },
    defaultMonthItem: {
      Number: '',
      Name: '',
      Quantity: 1,
      PayQuantity: 0,
      AddPayQuantity: 0,
      RentQuantity: 1,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0,
      PayType: 3,
      PayTimeRangeType: 1,
      PayQuantityType: 2,
      LicensePlate: ''
    },
    regexPrice: /^[0-9]+$/,
    regexQuantity: /^[0-9]+$/,
    regexDecimal: /^\d+\.?\d*$/,
    payTimeRangeTypeList: []
  }),
  async mounted () {
    await this.getAllPayTimeRangeType()
  },
  computed: {
    newMonthItemList () {
      let array = []
      this.monthItemList.forEach((element, index) => {
        array.push(Object.assign({ Index: index }, element))
      })
      return array
    },
    monthItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('unlimited_month_month_number'), align: 'start', value: 'MonthNumber' },
        { text: this.$t('month_quantity'), align: 'end', value: 'Quantity' },
        { text: this.$t('unlimited_month_pay_quantity'), align: 'end', value: 'PayQuantity' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'RentQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: this.$t('unlimited_month_discount'), align: 'end', value: 'Discount' },
        { text: this.$t('unlimited_month_discount_price'), align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          align: 'end',
          value: 'RentWarrantyPeriod'
        },
        { text: this.$t('unlimited_month_pay_type'), align: 'center', value: 'PayType' },
        {
          text: this.$t('unlimited_month_pay_time_range'),
          align: 'center',
          value: 'PayTimeRangeType'
        },
        {
          text: this.$t('unlimited_month_pay_quantity_type'),
          align: 'center',
          value: 'PayQuantityType'
        },
        { text: this.$t('transfer_order_license_plate'), align: 'start', value: 'LicensePlate' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: this.$t('common_move'), align: 'center', value: 'Move', sortable: false }
      ]
    }
  },
  methods: {
    turnPayQuantityTypeName (val) {
      return PayQuantityType.PayQuantityTypeName(val)
    },
    turnPayTimeRangeTypeName (val) {
      return PayTimeRangeType.PayTimeRangeTypeName(val)
    },
    async getAllPayTimeRangeType () {
      let response = await HttpMonth.GetPayTimeRangeTypes()
      this.payTimeRangeTypeList = response.status === 200 ? response.data.Data : []
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnPayType (val) {
      return PayType.PayTypeName(val)
    },
    setPayTypeAutocomplete (event) {
      this.$refs.payTypeAutocomplete.isMenuActive = false
      this.$refs.payTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    downMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.newMonthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllMonth', temp)
    },
    upMonthItem (item) {
      let temp = JSON.parse(JSON.stringify(this.newMonthItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllMonth', temp)
    },
    changeMonthTotal () {
      if (
        this.regexQuantity.test(this.editedMonthItem.RentQuantity) &&
        this.regexDecimal.test(this.editedMonthItem.Price) &&
        this.regexDecimal.test(this.editedMonthItem.PayQuantity) &&
        this.regexDecimal.test(this.editedMonthItem.AddPayQuantity) &&
        this.regexQuantity.test(this.editedMonthItem.Quantity) &&
        this.regexDecimal.test(this.editedMonthItem.Discount) &&
        this.regexDecimal.test(this.editedMonthItem.DiscountPrice)
      ) {
        this.editedMonthItem.DiscountPrice =
          this.editedMonthItem.Price - this.editedMonthItem.Discount
        const quantityMultiplier =
          this.editedMonthItem.PayType === this.payType.Quantity
            ? Math.max(
              0,
              this.editedMonthItem.AddPayQuantity * 1 + this.editedMonthItem.PayQuantity * 1
            )
            : 1
        this.editedMonthItem.TotalPrice = Math.round(
          this.editedMonthItem.RentQuantity *
            this.editedMonthItem.DiscountPrice *
            this.editedMonthItem.Quantity *
            quantityMultiplier *
            1
        )
      }
    },
    setEditedMonthItem (val) {
      this.editedMonthItem.Id = val.Id
      this.editedMonthItem.Number = val.Number
      this.editedMonthItem.Name = val.Name
      this.editedMonthItem.Unit = val.Unit
      this.editedMonthItem.Price = val.Price
      this.editedMonthItem.IsMonthItem = val.IsMonthItem
      this.editedMonthItem.IsDelete = val.IsDelete
      this.editedMonthItem.StoreNo = val.StoreNo
      this.editedMonthItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedMonthItem.Remark = val.Remark
      this.changeMonthTotal()
      this.editedMonthItem = JSON.parse(JSON.stringify(this.editedMonthItem))
    },
    closeEditedMonthItem () {
      this.isShowEditMonthItemDialog = false
      this.editedMonthItem = JSON.parse(JSON.stringify(this.defaultMonthItem))
      this.editedMonthItemIndex = -1
      this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
    },
    openMonthItem () {
      this.editedMonthItem.RentQuantity = this.carQuantity
      this.isShowEditMonthItemDialog = true
    },

    closeDeleteMonthItem () {
      this.editedMonthItemIndex = -1
      this.isShowDeleteMonthItemDialog = false
      this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
    },

    async saveEditedMonthItem () {
      const isValid = await this.$refs.dialogMonthItem.validate()
      if (isValid) {
        this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
        this.$emit('setMonthItem', this.editedMonthItem)
        this.closeEditedMonthItem()
      }
    },

    confirmDeleteMonthItem () {
      this.$emit('setMonthItemIndex', this.editedMonthItemIndex)
      this.$emit('deleteMonthItem')
      this.closeDeleteMonthItem()
    },
    isShowEditMonthItemDialogBtn (item) {
      this.editedMonthItemIndex = this.newMonthItemList.indexOf(item)
      this.editedMonthItem = JSON.parse(JSON.stringify(item))
      this.isShowEditMonthItemDialog = true
    },
    isShowDeleteMonthItemDialogBtn (item) {
      this.editedMonthItemIndex = this.newMonthItemList.indexOf(item)
      this.isShowDeleteMonthItemDialog = true
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'allPayQuantityType'
  ]
}
</script>
